export default __webpack_public_path__ + "static/media/broker-banner1.ae26204d.jpg";